module.exports = __webpack_public_path__ + "static/media/celular-14dic.f2f7d71f.svg";